import type { WorkflowAction, WorkflowActionType } from '../workflow.types';
import { ConnectionRespModel } from '@models/connection/ConnectionRespModel';

export class WorkflowActionModel {
  private readonly _dto: WorkflowAction;
  private readonly _connection: ConnectionRespModel;

  constructor(dto: WorkflowAction) {
    this._dto = dto;
    this._connection = dto.connection ? new ConnectionRespModel(dto.connection) : new ConnectionRespModel({});
  }

  get originDTO(): WorkflowAction {
    return this._dto;
  }

  get actionArguments(): unknown {
    return this._dto.actionArguments;
  }

  get connectionId(): string {
    return this._dto.connectionId || '';
  }

  get method(): string {
    return this._dto.method || '';
  }

  get type(): WorkflowActionType {
    return this._dto.type || 'CONNECTION_ACTION';
  }

  get connection(): ConnectionRespModel {
    return this._connection;
  }
}
